exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#tree-panel{width:40%;flex-grow:1;overflow-y:scroll;resize:horizontal;box-sizing:border-box;background-color:var(--tree-panel-color);padding-left:var(--horizontal-panel-padding);padding-right:var(--horizontal-panel-padding)}#tree-panel .panel-title .user-select{margin-left:1em}#tree-panel .tree-panel-filter{margin-bottom:2em}#tree-panel .subtree-filter{display:flex;align-items:center;border-top:1px dotted gray;border-bottom:1px dotted gray;padding-top:.2em;padding-bottom:.2em}#tree-panel .subtree-filter .infobit{flex:auto;min-width:0}#tree-panel .subtree-filter button{flex:none;visibility:hidden}#tree-panel .subtree-filter:hover button{visibility:visible}#tree-panel .empty-tree-drop-area{border:1px dotted #c7c7c7;font-size:var(--small-font-size);color:gray;width:75%;height:4em;padding:.5em}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-32a26c2a!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/tree-panel.vue
// module id = 84
// module chunks = 0